<!-- YouTube Shorts ad on the TV app -->
<app-tv-frame>
  <!-- START: TV screen -->
  <div class="yt-tv-screen d-flex flex-row">
    <!-- START: Player area — the creative is as tall as the screen and sits
         against the column, so a narrow creative leaves the dark band on its
         left rather than being centred. -->
    <div class="yt-tv-player-area d-flex flex-row justify-content-end">
      <div class="yt-tv-player" [style.aspect-ratio]="aspectRatio">
        <img
          *ngIf="thumbnailUrl; else noCreative"
          class="yt-tv-creative"
          [src]="thumbnailUrl"
          alt=""
        />

        <ng-template #noCreative>
          <div class="yt-tv-creative creative-missing">
            <ng-container *ngIf="isResolving; else askForVideo">
              Reading video formats&hellip;
            </ng-container>
            <ng-template #askForVideo>
              Add a {{ format }} video to see this preview
            </ng-template>
          </div>
        </ng-template>
      </div>
    </div>
    <!-- END: Player area -->

    <!-- START: Companion column. Drawn whether or not there is a creative yet:
         unlike the overlaid placements, this copy sits on the set's own dark
         screen rather than on the picture. -->
    <div class="yt-tv-column d-flex flex-column justify-content-end">
      <div class="yt-tv-sponsored">Sponsored</div>

      <h4 class="yt-tv-headline">{{ headline }}</h4>

      <div class="yt-tv-channel d-flex flex-row align-items-center">
        <img class="yt-tv-avatar" src="assets/images/valamar_logo_80x80.jpg" alt="" />
        <span class="yt-tv-brand">Valamar</span>
      </div>

      <!-- The remote's buttons. Fixed copy: it is the ad's frame, not the
           author's, and the TV app shows no call to action of its own. -->
      <div class="yt-tv-actions d-flex flex-row align-items-center">
        <i class="bi bi-hand-thumbs-up-fill"></i>
        <i class="bi bi-hand-thumbs-down-fill"></i>
        <i class="bi bi-info-circle-fill"></i>
      </div>
    </div>
    <!-- END: Companion column -->
  </div>
  <!-- END: TV screen -->
</app-tv-frame>
